// Drag-to-pan for a native scroll element. The caller forwards the pointer/keydown events; this owns
// the drag mechanics, the `gantt--panning` class on `containerRef` and ESC-to-revert.
export function useTimelinePan(containerRef) {
  let hEl = null
  let vEl = null
  let startX = 0
  let startY = 0
  let startLeft = 0
  let startTop = 0

  const isPanning = () => hEl !== null || vEl !== null

  // `verticalScroller` is null for a horizontal-only pan.
  const beginElement = (event, horizontalScroller, verticalScroller) => {
    hEl = horizontalScroller
    vEl = verticalScroller
    if (!isPanning()) return
    event.preventDefault()
    event.stopPropagation()
    startX = event.clientX
    startY = event.clientY
    startLeft = hEl?.scrollLeft ?? 0
    startTop = vEl?.scrollTop ?? 0
    containerRef.value?.classList.add('gantt--panning')
  }

  // Drive the active pan from a pointermove; returns true when it consumed the event.
  const move = (event) => {
    if (!isPanning()) return false
    event.preventDefault()
    if (hEl) hEl.scrollLeft = startLeft - (event.clientX - startX)
    if (vEl) vEl.scrollTop = startTop - (event.clientY - startY)
    return true
  }

  const end = () => {
    hEl = null
    vEl = null
    containerRef.value?.classList.remove('gantt--panning')
  }

  // Cancel the active pan (ESC), restoring the scroll position it started from.
  const revert = () => {
    if (!isPanning()) return false
    if (hEl) hEl.scrollLeft = startLeft
    if (vEl) vEl.scrollTop = startTop
    end()
    return true
  }

  return { isPanning, beginElement, move, end, revert }
}
